import { Suspense } from "react";
import OpenGraphTag from "components/OpenGraphTag/OpenGraphTag";
import TawkChatWidget from "components/TawkChatWidget/TawkChatWidget";
import MyRouter from "routers/index";

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <OpenGraphTag />
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
        <MyRouter />
      </Suspense>
      <TawkChatWidget />
    </div>
  );
}

export default App;
